/**
 * Constants related to offline mode functionality
 * These values are used throughout the application to ensure consistent
 * offline experience and messaging
 */

export const OFFLINE_CONSTANTS = {
  // Status and display text
  OFFLINE_STATUS_TEXT: "You're offline. Some features may be limited.",
  POOR_CONNECTION_TEXT: "Poor connection detected. Using offline mode.",
  ALPHA_TAG: "ALPHA",
  
  // Colors - keeping consistent with the app's design system
  ONLINE_PRIMARY_COLOR: "purple",
  OFFLINE_PRIMARY_COLOR: "gray",
  ONLINE_ACCENT_COLOR: "purple-600",
  OFFLINE_ACCENT_COLOR: "gray-600",
  
  // Offline page content
  OFFLINE_PAGE_TITLE: "You're Offline",
  OFFLINE_PAGE_MESSAGE: "You don't have an internet connection right now. Some features may be unavailable until you're back online.",
  OFFLINE_AVAILABLE_TITLE: "Available Offline",
  OFFLINE_RETRY_BUTTON: "Retry Connection",
  
  // Cache names and versions for service worker
  CACHE_NAME: "meduler-offline-cache-v1",
  OFFLINE_DATA_KEY: "meduler-offline-data",
  
  // Network retry settings
  CONNECTION_RETRY_INTERVAL: 30000, // 30 seconds
  
  // Paths that should be available offline
  CRITICAL_OFFLINE_PATHS: [
    "/",
    "/index.html",
    "/about",
    "/offline"
  ]
};
